/**
 * @generated SignedSource<<d9cc54fc88782605eb9ffbd21f6adfd8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type commentSummary_nativeIssueTable_CommentSummaryCell$data = {
  readonly commentSummary: {
    readonly canAddComment: boolean | null | undefined;
    readonly totalCount: number | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "commentSummary_nativeIssueTable_CommentSummaryCell";
};
export type commentSummary_nativeIssueTable_CommentSummaryCell$key = {
  readonly " $data"?: commentSummary_nativeIssueTable_CommentSummaryCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"commentSummary_nativeIssueTable_CommentSummaryCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "commentSummary_nativeIssueTable_CommentSummaryCell",
  "selections": [
    {
      "concreteType": "JiraCommentSummary",
      "kind": "LinkedField",
      "name": "commentSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "canAddComment"
        },
        {
          "kind": "ScalarField",
          "name": "totalCount"
        }
      ]
    }
  ],
  "type": "JiraCommentSummaryField"
};

(node as any).hash = "91bb4bde7c95d88894f72343be5f8adf";

export default node;
